"use client";

import { getGtmUserData } from "@/helpers/getGtmUserData";
import { sendGTMEvent } from "@/helpers/sendGTMEvent";
import { useRouter } from "@/i18n/navigation";
import { useAuth } from "@/providers/AuthProvider";
import { ChevronRight } from "lucide-react";
import Image, { StaticImageData } from "next/image";

interface PropsType {
  index: number;
  href: string;
  image_url: string | StaticImageData;
  countryName: string;
  setShowDialog?: React.Dispatch<React.SetStateAction<boolean>>;
}

function CountryItem({
  countryName,
  href,
  image_url,
  setShowDialog,
}: PropsType) {
  const router = useRouter();
  const { user } = useAuth();
  return (
    <button
      type="button"
      className="flex w-full items-center justify-between rounded-full p-2 text-start transition hover:bg-secondary"
      onClick={() => {
        sendGTMEvent({
          event: "search",
          search_term: countryName,
          user_data: getGtmUserData(user?.name),
        });
        router.push(href);
        setShowDialog?.(false);
      }}
    >
      <span className="flex items-center gap-3">
        <span className="relative h-[20px] w-[30px]">
          <Image
            src={image_url}
            alt={`${countryName} Packages`}
            className="rounded object-cover shadow-lg"
            fill
          />
        </span>
        <span className="text-sm font-500 text-foreground-light">
          {countryName}
        </span>
      </span>

      <ChevronRight size={22} />
    </button>
  );
}

export default CountryItem;
